export default function ({ app, $auth, route, redirect }) {
    // ユーザが認証されていないとき
    if (!$auth.loggedIn) {
        redirect(app.$page.login + '?redirect=' + route.fullPath);
    }
}